import {
	LOADING_MODAL_I18N_KEYS
} from '../../../../../features/topics/components/constants/i18n/LoadingModali18nConstants';

export const LOADING_MODAL_I18N_EN = {
	[LOADING_MODAL_I18N_KEYS.uploading]: "Uploading",
	[LOADING_MODAL_I18N_KEYS.cancel]:    "Cancel"
}



// WEBPACK FOOTER //
// ./src/locales/en/features/topics/components/loading_modal.i18n.en.js